import { useCurrency } from '../context/CurrencyContext';
import { CURRENCY_OPTIONS } from '../utils/currency';
import { Select, SelectContent, SelectItem, SelectTrigger } from './ui/select';

export const CurrencySelector = () => {
  const { secondaryCurrency, setCurrency } = useCurrency();

  const current = CURRENCY_OPTIONS[secondaryCurrency] || CURRENCY_OPTIONS.fmg;

  return (
    <Select value={secondaryCurrency} onValueChange={setCurrency}>
      <SelectTrigger className="h-auto w-auto border-0 bg-transparent shadow-none px-0 py-0 text-xs font-normal text-text_muted hover:text-text_main focus:ring-0 focus:ring-offset-0 gap-0.5" data-testid="currency-selector">
        <span>{current.symbol} {current.label}</span>
      </SelectTrigger>
      <SelectContent>
        {Object.entries(CURRENCY_OPTIONS).map(([key, opt]) => (
          <SelectItem key={key} value={key} data-testid={`currency-option-${key}`}>
            {opt.symbol} {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
